export default "/images/vendor/flag-icon-css/flags/1x1/bf.svg?6fc31e160aec39c1d496a8a13554b6ad";